export const getUserProfileUrl = (name: string, id: string) => {
  if (!name || name === undefined || !id || id === undefined) return

  const newArr = name?.split(" ")
  const lowercaseArr = newArr?.map(item => item?.toLowerCase())

  return `${lowercaseArr?.join("_")}-${id}`
}
